import { render, staticRenderFns } from "./QuestionManager.vue?vue&type=template&id=b4347084&scoped=true"
import script from "./QuestionManager.vue?vue&type=script&lang=ts"
export * from "./QuestionManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4347084",
  null
  
)

export default component.exports